<template>
  <section>
    <div>
      <div id="compare" v-if="list.length >= 2" class="mt-8">
        <h2 class="page-title mb-5">Comparison Details</h2>

        <div class="w-full">
          <Accordion title="Childcare Experience">
            <div
              v-for="(aupair, index) in list"
              :key="index"
              class="flex flex-col lg:flex-row justify-center items-center text-center mb-5 hours border-b border-purple-ap-t03"
            >
              <div class="w-1/3">
                <h4 class="mb-3 font-bold">{{ aupair.firstName }}</h4>
              </div>

              <div class="text-left w-2/3">
                <p>
                  {{ aupair.childcareSummary }}
                </p>
              </div>
            </div>
          </Accordion>
          <Accordion title="Childcare Hours of Experience by Age Group">
            <div class="flex flex-col w-full justify-between items-center mt-5">
              <div
                v-for="(aupair, index) in list"
                :key="index"
                class="flex flex-col w-full lg:flex-row justify-between items-center text-center mb-5 hours border-b border-purple-ap-t03"
              >
                <div class="w-1/3">
                  <h4 class="mb-3 font-bold">{{ aupair.firstName }}</h4>
                </div>

                <div
                  class="w-2/3 flex items-center justify-between flex-col md:flex-row"
                >
                  <div class="text-center">
                    <p>
                      <strong>Under 1</strong>
                    </p>
                    <p>
                      {{
                        aupair.childcareExperienceUnder1 > 0
                          ? `${aupair.childcareExperienceUnder1}`
                          : `0`
                      }}
                    </p>
                  </div>
                  <div class="text-center">
                    <p>
                      <strong>Under 2</strong>
                    </p>
                    <p>
                      {{
                        aupair.childcareExperienceUpTo2 > 0
                          ? `${aupair.childcareExperienceUpTo2}`
                          : `0`
                      }}
                    </p>
                  </div>
                  <div class="text-center">
                    <p>
                      <strong>Up to 5</strong>
                    </p>
                    <p>
                      {{
                        aupair.childcareExperienceUpTo5 > 0
                          ? `${aupair.childcareExperienceUpTo5}`
                          : `0`
                      }}
                    </p>
                  </div>
                  <div class="text-center">
                    <p>
                      <strong>Up to 10</strong>
                    </p>
                    <p>
                      {{
                        aupair.childcareExperienceUpTo10 > 0
                          ? `${aupair.childcareExperienceUpTo10}`
                          : `0`
                      }}
                    </p>
                  </div>
                  <div class="text-center">
                    <p>
                      <strong>Over 10</strong>
                    </p>
                    <p>
                      {{
                        aupair.childcareExperienceOver10 > 0
                          ? `${aupair.childcareExperienceOver10}`
                          : `0`
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Accordion>
          <Accordion title="Driving">
            <div
              v-for="(aupair, index) in list"
              :key="index"
              class="flex flex-col md:flex-wrap md:flex-row justify-between items-center text-center mb-5 hours border-b border-purple-ap-t03"
            >
              <div class="md:w-1/3">
                <h4 class="mb-3 font-bold">{{ aupair.firstName }}</h4>
              </div>

              <div class="md:w-2/3 px-5">
                <h3>More than 1 year of experience?</h3>
                <p>{{ aupair.experiencedDriver ? "Yes" : "No" }}</p>
              </div>

              <div>
                <p class="text-left md:flex-1">
                  {{ aupair.drivingSkills }}
                </p>
              </div>
            </div>
          </Accordion>
          <Accordion title="Swimming">
            <div
              v-for="(aupair, index) in list"
              :key="index"
              class="flex flex-col w-full lg:flex-row justify-center items-center text-center mb-5 hours border-b border-purple-ap-t03"
            >
              <div class="md:w-1/3">
                <h4 class="mb-3 font-bold">{{ aupair.firstName }}</h4>
              </div>

              <div class="md:flex-1 px-5 text-center">
                <h3>Can Swim?</h3>
                <p>{{ aupair.swimmer ? "Yes" : "No" }}</p>
              </div>
            </div>
          </Accordion>
          <Accordion title="English Proficiency">
            <div
              v-for="(aupair, index) in list"
              :key="index"
              class="flex flex-col w-full lg:flex-row justify-center items-center text-center mb-5 hours border-b border-purple-ap-t03"
            >
              <div class="md:w-1/3">
                <h4 class="mb-3 font-bold">{{ aupair.firstName }}</h4>
              </div>

              <div class="md:flex-1 px-5 text-center">
                <h3>English Proficiency</h3>
                <p>{{ aupair.englishProficiency }}</p>
              </div>
            </div>
          </Accordion>
        </div>
      </div>
      <div
        class="compare bg-white mb-4 rounded-b-lg rounded-t p-5 mt-8 text-center"
        v-else-if="aupairs && aupairs.length > 0"
      >
        <p>
          Compare your favorites!
          <br />
          Click "compare" on {{ `${2 - list.length}` }} or more Au Pairs to
          start.
        </p>
      </div>
      <div v-if="this.list.length >= 2" class="view-comparison">
        <a href="#compare">View Comparison</a>
      </div>
    </div>
  </section>
</template>

<script>
import Accordion from "@/components/UI/Accordion.vue";
export default {
  name: "ComparisonTable",
  props: {
    list: Array,
    aupairs: Array,
  },
  components: {
    Accordion,
  },
};
</script>

<style scoped>
.compare {
  border: 4px dashed;
  @apply border-purple-ap-t03;
}

.compare p {
  font-size: 1.3rem;
  @apply text-purple-ap-t09;
}

.view-comparison {
  @apply bg-green-600;
  position: fixed;
  bottom: 10px;
  right: 10px;
  margin: auto;
  padding: 12px 10px;
  border-radius: 4px;
  @apply shadow-lg;
  text-align: center;
}

.view-comparison a {
  color: #fff;
  vertical-align: middle;
  font-size: 0.8rem;
  font-weight: 600;
}

.hours h3 {
  @apply text-purple-ap-100;
  @apply uppercase;
  font-size: 1rem;
  @apply font-semibold;
}

.hours:last-child {
  margin-bottom: 0;
}

.hours p {
  font-size: 0.9rem;
}

.hours > div {
  @apply mb-4;
}

.border-b:last-child {
  border: none;
}
</style>
